



import { Component, Vue, Prop } from "vue-property-decorator";
import * as Common from "@/agiles/common";

@Component
export default class PayJPCheckout extends Vue {
 @Prop({default:''}) public caption:string;
 @Prop({default:null}) public perm:string; 
  public scriptTag: Element;
  public mounted() {
    if (this.hasPerm){
        (window as any).onCardCreatedPayJP = this.onCardCreatedPayJP;
        let payJPscript = document.createElement("script");
        payJPscript.setAttribute("src", "https://checkout.pay.jp/");
        payJPscript.setAttribute("class", "payjp-button");
        // payJPscript.setAttribute("data-key", "pk_test_ecc1d4676c78ef3dad60a42a");
        payJPscript.setAttribute("data-key", process.env.VUE_APP_PAYJP);
        payJPscript.setAttribute("data-on-created", "onCardCreatedPayJP");
        payJPscript.setAttribute("data-text", this.caption);
        payJPscript.setAttribute("data-submit-text", "カード情報を登録する");
        payJPscript.setAttribute("data-partial", "true");
        payJPscript.setAttribute("data-payjp-three-d-secure", "true");
        payJPscript.setAttribute("data-payjp-three-d-secure-workflow", "subwindow");
        this.scriptTag = payJPscript;
        this.$el.appendChild(payJPscript);
    }
  }

  public get hasPerm(){
      return this.perm ? this.$api.perms.hasMenuPermission(this.perm) : true;
  }
  public onCardCreatedPayJP(arg: any) {
      this.$emit('click',arg);
      this.$nextTick(()=>{
          (document.getElementById("payjp_checkout_box").firstChild as HTMLInputElement).value = this.caption;
          });
  }

  public beforeDestroy() {
    this.$el.removeChild(this.scriptTag);
    document.getElementById("payjp-checkout-iframe").parentElement.remove();
    (window as any).PayjpCheckout = null;
    (window as any).onCardCreatedPayJP = null;
  }
}
